import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { X, KeyRound, RefreshCw, Copy, Check } from "lucide-react";

function genPassword() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  let p = "";
  for (let i = 0; i < 10; i++) p += chars[Math.floor(Math.random() * chars.length)];
  return p + "@1";
}

export default function ResetPasswordModal({ user, onClose }) {
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [copied, setCopied] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!password || password.length < 6) { toast.error("Au moins 6 caractères"); return; }
    setSaving(true);
    try {
      await api.post(`/admin/users/${user.id}/reset-password`, { password });
      toast.success("Mot de passe réinitialisé");
      setDone(true);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const copy = () => {
    navigator.clipboard?.writeText(`Email: ${user.email}\nMot de passe: ${password}`);
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };

  const input = "mt-1 w-full h-10 px-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 transition-shadow text-sm";

  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="reset-password-modal">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-lg text-slate-900 flex items-center gap-2"><KeyRound className="h-5 w-5 text-indigo-600" /> Dépanner l'accès</h3>
          <button onClick={onClose}><X className="h-5 w-5 text-slate-400" /></button>
        </div>

        <div className="rounded-lg bg-slate-50 border border-slate-200 p-3 mb-4">
          <div className="text-xs font-semibold text-slate-400 uppercase">Identifiant (login)</div>
          <div className="text-sm font-bold text-slate-900 num mt-0.5" data-testid="reset-user-email">{user.email}</div>
          <div className="text-xs text-slate-400 mt-0.5">{user.pharmacy_name || user.supplier_name || user.name}</div>
        </div>

        {!done ? (
          <>
            <label className="text-sm font-semibold text-slate-700">Nouveau mot de passe</label>
            <div className="flex gap-2">
              <input data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className={input + " flex-1"} placeholder="Saisir ou générer" />
              <button onClick={() => setPassword(genPassword())} data-testid="generate-password" className="mt-1 h-10 px-3 rounded-lg border border-slate-300 hover:bg-slate-50 text-slate-600 transition-colors duration-200" title="Générer"><RefreshCw className="h-4 w-4" /></button>
            </div>
            <p className="mt-2 text-xs text-slate-400">Communiquez ce mot de passe à l'adhérent. Il pourra le modifier ensuite.</p>
            <button onClick={submit} disabled={saving} data-testid="confirm-reset" className="mt-5 w-full h-11 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors duration-200 disabled:opacity-60">
              Réinitialiser le mot de passe
            </button>
          </>
        ) : (
          <div data-testid="reset-success">
            <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4">
              <div className="text-xs font-semibold text-emerald-700 uppercase">Identifiants à communiquer</div>
              <div className="mt-2 text-sm num"><span className="text-slate-500">Email :</span> <span className="font-bold text-slate-900">{user.email}</span></div>
              <div className="text-sm num"><span className="text-slate-500">Mot de passe :</span> <span className="font-bold text-slate-900">{password}</span></div>
            </div>
            <button onClick={copy} data-testid="copy-credentials" className="mt-4 w-full h-11 rounded-lg border border-slate-300 hover:bg-slate-50 text-slate-700 font-semibold flex items-center justify-center gap-2 transition-colors duration-200">
              {copied ? <><Check className="h-4 w-4 text-emerald-600" /> Copié</> : <><Copy className="h-4 w-4" /> Copier les identifiants</>}
            </button>
            <button onClick={onClose} className="mt-2 w-full h-11 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors duration-200">Fermer</button>
          </div>
        )}
      </div>
    </div>
  );
}
